import { Component, Input } from '@angular/core';

type SupportContextType = 'deposit' | 'withdrawal' | 'order' | 'compliance' | 'general';

@Component({
  selector: 'app-support-context-card',
  standalone: false,
  templateUrl: './support-context-card.html',
  styleUrl: './support-context-card.css'
})
export class SupportContextCard {
  @Input() type: SupportContextType = 'general';
  @Input() title = 'Need help?';
  @Input() subtitle = 'Get help from SwipFx support.';
  @Input() suggestedQuestion = '';

  get helpCenterLink(): string {
    return '/support';
  }

  get quickQuestions(): string[] {
    switch (this.type) {
      case 'deposit':
        return [
          'Which deposit channels are available to me?',
          'My deposit is pending',
          'Do I have an additional document request?'
        ];
      case 'withdrawal':
        return [
          'What is my withdrawal status?',
          'Why was my withdrawal rejected?',
          'How long do withdrawals take?'
        ];
      case 'order':
        return [
          'What is my order status?',
          'Explain Instant versus Flexible rates',
          'Why did my Instant quote change?'
        ];
      case 'compliance':
        return [
          'Why is my account restricted?',
          'What documents do I need for KYC?',
          'What is my verification status?'
        ];
      default:
        return [
          'How do I get help?',
          'How do I contact support?',
          'Where can I see my tickets?'
        ];
    }
  }

  openSupport(question: string): void {
    window.dispatchEvent(
      new CustomEvent('swipfx-support-open', {
        detail: { question }
      })
    );
  }
}